import instance from "api/apiClient";
import { apiRoutes } from "configs/apiRoutes";

export interface GetListPayload {
  page?: number;
  limit?: number;
  title?: string;
  isActive?: number;
}

export const getGamesCollectionsListService = async (data: GetListPayload) => {
  try {
    const res = await instance.post(apiRoutes.collectionsList, data);
    return res.data.items || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getCollectionsByIdsService = async (ids: number[]) => {
  try {
    const res = await instance.post(apiRoutes.collectionsList, { ids });
    return res.data.items || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};
